import React from 'react';
import { ReceiptText } from 'lucide-react';
import { AdminPageScaffold } from '@/components/core/AdminPageScaffold';
import { StandardPageHeader } from '@/components/layout/StandardPageHeader';
import InvoicesContainer from '@/components/invoices/InvoicesContainer';
import { useSearchParams } from 'react-router-dom';

const statusMap: Record<string, string[]> = {
  pending: ['unpaid', 'overdue'],
  unpaid: ['unpaid'],
  overdue: ['overdue'],
  paid: ['paid'],
  draft: ['draft'],
  partial: ['partial'],
};

const Invoices: React.FC = () => {
  const [searchParams] = useSearchParams();
  const filter = searchParams.get('filter');
  let initialStatuses: string[] | undefined = undefined;
  if (filter) {
    const filters = filter.split(',');
    initialStatuses = filters.flatMap(f => statusMap[f] || []);
  }

  return (
    <>
      <StandardPageHeader
        title="Invoices"
        subtitle="Manage invoices and payments for your hive's families"
        icon={ReceiptText}
      />
      
      <AdminPageScaffold>
        <InvoicesContainer initialStatuses={initialStatuses} />
      </AdminPageScaffold>
    </>
  );
};

export default Invoices;
